import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  TextField,
  TableContainer,
  Typography,
} from "@mui/material";
import VantageListHead from "../../../../../component/ListHead/SignalList";
import {
  Tablecell,
  applySortFilter,
  formatValue,
  getComparator,
  findStrategy,
} from "../../../../../component/Methods";
import { useSelector } from "react-redux";

const Blacklisted = ({
  blacklist,
  tableHeader,
  totalBlacklistedTickers,
  totalTickersChecked,
}) => {
  const theme = useTheme();
  const [data, setData] = useState(blacklist);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("ticker");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    const filteredData = applySortFilter(
      blacklist,
      getComparator(order, orderBy)
    );
    setData(filteredData);
  }, [order, orderBy, blacklist]);

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "4px",
        width: "100%",
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <TableContainer
        sx={{
          flex: "1 1 0px",
          minHeight: 0,
          height: 0,
          maxHeight: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          display: "block",
        }}
      >
        <Table
          size="small"
          stickyHeader
          aria-label="a dense table"
        >
            <VantageListHead
              order={order}
              orderBy={orderBy}
              headLabel={tableHeader}
              noStatus={true}
              customizeFont={12}
              rowCount={data?.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {data?.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: theme.palette.background.paper,
                    "&:hover": {
                      background: theme.palette.action.hover,
                      cursor: "pointer",
                      borderColor: theme.palette.divider,
                    },
                  }}
                >
                  <Tablecell
                    align="left"
                    sx={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      backgroundColor: theme.palette.background.paper,
                      borderColor: theme.palette.divider,
                      width: "20%",
                    }}
                  >
                    {row?.fund}
                  </Tablecell>
                  <Tablecell
                    align="left"
                    sx={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      backgroundColor: theme.palette.background.paper,
                      borderColor: theme.palette.divider,
                      width: "20%",
                    }}
                  >
                    {row?.strategy}
                  </Tablecell>
                  <Tablecell
                    align="left"
                    sx={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      backgroundColor: theme.palette.background.paper,
                      borderColor: theme.palette.divider,
                      width: "20%",
                    }}
                  >
                    {row?.ticker?.toUpperCase() || ""}
                  </Tablecell>
                  <Tablecell
                    align="left"
                    sx={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      backgroundColor: theme.palette.background.paper,
                      borderColor: theme.palette.divider,
                      width: "40%",
                    }}
                  >
                    {row?.reason}
                  </Tablecell>
                  <Tablecell
                    align="left"
                    sx={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      backgroundColor: theme.palette.background.paper,
                      borderColor: theme.palette.divider,
                      width: "20%",
                    }}
                  >
                    {row?.direction
                      ? row?.direction?.charAt(0)?.toUpperCase() +
                        row?.direction?.slice(1)?.toLowerCase()
                      : ""}
                  </Tablecell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
         
      </TableContainer>
    </Box>
  );
};

export default Blacklisted;
